import script from "./pending-approval-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./pending-approval-list.vue?vue&type=script&setup=true&lang=ts"

import "./pending-approval-list.vue?vue&type=style&index=0&id=1264e7c6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1264e7c6"]])

export default __exports__